<template>
  <li class="permissions-group">
    <h4 class="permissions-group__title">{{ permission.name }}</h4>
    <ul class="permissions-group__list">
      <li v-for="(item, key) in permission.items" :key="key">
        <v-checkbox
          v-model="selected"
          color="warning"
          :label="item.description"
          :value="item.id"
          dense
          hide-details
        />
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    permission: {
      type: Object,
      required: true,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
};
</script>

<style lang="scss">
.permissions-group {
  width: 25%;
  list-style: none;
  padding: 10px;

  @media (max-width: 900px) {
    width: 50%;
    padding: 0;
    margin-bottom: 15px;
  }

  &__title {
    font-size: 16px;
    color: #464646;
  }

  &__list {
    padding: 0 !important;
    margin: 0;

    li {
      padding: 0;
      margin: 0;
      list-style: none;
    }
  }

  .v-label {
    font-size: 15px;
    height: auto;
  }

  .v-input__slot {
    align-items: flex-start;
  }

  .v-input--selection-controls {
    margin-top: 10px;
  }

  .v-input--checkbox .v-icon {
    margin-right: 10px;
  }
}
</style>
